import React, { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

function MinKNOWDirectoryUpload({ onDirectorySelected, pasteInstructions, disabled = false }) {
  const [showPasteHint, setShowPasteHint] = useState(false);
  const handleDrop = (acceptedFiles) => {
    setShowPasteHint(false);
    onDirectorySelected?.(acceptedFiles);
  };
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop: handleDrop,
    onFileDialogCancel: () => setShowPasteHint(false),
    multiple: true,
    noClick: false,
    noKeyboard: false,
    disabled
  });

  const style = useMemo(() => {
    const base = {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '20px',
      borderWidth: 2,
      borderRadius: 2,
      borderColor: '#eeeeee',
      borderStyle: 'dashed',
      backgroundColor: '#fafafa',
      color: '#bdbdbd',
      cursor: disabled ? 'not-allowed' : 'pointer',
      outline: 'none',
      transition: 'border .24s ease-in-out'
    };

    const focusedStyle = { borderColor: '#2196f3' };
    const acceptStyle = { borderColor: '#00e676' };
    const rejectStyle = { borderColor: '#ff1744' };
    const disabledStyle = { opacity: 0.6 };

    return {
      ...base,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      ...(disabled ? disabledStyle : {})
    };
  }, [isFocused, isDragAccept, isDragReject, disabled]);


  return (
    <Box>
      <Box
        {...getRootProps({
          style,
          onClick: () => {
            if (!disabled) {
              setShowPasteHint(true);
            }
          }
        })}
      >
        <input {...getInputProps()} webkitdirectory="" directory="" />
        <Typography variant="h6" color="textPrimary" sx={{ mb: 1 }}>
          Upload from Gourami output directory
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Click to select or drag/drop Gourami output directory as found in the Gourami Application.
        </Typography>
        <Typography variant="body2" color="textSecondary" component="div" sx={{ fontSize: '12px', fontWeight: 600, wordBreak: 'break-all', whiteSpace: 'normal' }}>
          (example directory <pre style={{ display: 'inline', margin: 0, padding: 0, fontSize: '12px', fontWeight: 600, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>/Users/my.username/data/./ECOLI_TEST/my-sample-1/20221014_1522_X3_FAU00546_23edea9</pre>)
        </Typography>
      </Box>
      <Snackbar
        open={Boolean(pasteInstructions) && showPasteHint}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" variant="filled">
          <b>{pasteInstructions}</b>
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default MinKNOWDirectoryUpload;

